import { ProductPropertyType } from '@shared/types/product';

export const getCellValue = (props: ProductPropertyType) => {
  if (!props) {
    return '-';
  }
  if (props.type.name === 'Number' && props?.unit) {
    return `${props.values[0].value} ${props.unit.shortName}`;
  }

  if (props?.type.name === 'String') {
    return props.values[0].value;
  }

  if (props?.type.name === 'Boolean') {
    return props.values[0].value === 'true' ? 'Да' : 'Нет';
  }

  return '-';
};
